import { UserActions } from '@next/core-lib/user';
import { createReducer, on } from '@ngrx/store';

import { FeedState } from '../../models/feed.model';
import * as FeedActions from '../actions/feed.actions';

export const initialState: FeedState = {
  deliveryLines: [],
};

export const feedReducer = createReducer<FeedState>(
  initialState,
  on(FeedActions.loadDeliveryLinesSuccess, (state, { deliveryLines }) => ({
    ...state,
    deliveryLines,
  })),
  on(UserActions.relationshipSelected, () => initialState),
);
